document.addEventListener('DOMContentLoaded', () => {
	const [option1, option2] = document.querySelectorAll('.option');
	const [package1, package2] = document.querySelectorAll('.package');
	const checkoutOrWebShop = document.querySelector('.standard-option');
	const gravityForms = [...document.querySelectorAll('[data-js-reload^=field_3]')].filter((el) => +el.dataset.jsReload.slice(8) >= 10);

	const [packet, system, period, usersForm, extras, monthly, oneTime] = gravityForms;
	const userButtons = document.querySelectorAll('.user');
	const { checkedOptions } = useGetLocalStorage('contrl-checkout');

	const backToContrlButton = document.querySelector('.wow-cool'); //TODO: CHANGE
	const checkout = document.querySelector('.system-kassa');
	const webshop = document.querySelector('.system-webshop');
	const twelveMonthContract = document.querySelector('.contract-12');
	const threeMonthContract = document.querySelector('.contract-3');
	const nextButton = document.querySelectorAll('.nextButton');
	const [...systems] = document.querySelectorAll('.system');
	const checkBoxes = document.querySelectorAll('.checkbox-single');

	nextButton.forEach((el) => el.addEventListener('click', switchTab));
	const summaryButton = document.querySelector('.summary-button');
	summaryButton.addEventListener('click', () => {
		const btnName = summaryButton.querySelector('span');
		btnName.textContent === 'Summering' ? (btnName.textContent = 'Stäng') : 'Summering';
	});
	systems.forEach((system, i) => {
		system.addEventListener('click', () => selectCheckbox(systems, i, '.system-type', 'selectedSystem'));
	});

	const arr = [];

	function switchTab() {
		const map = { tab1: 'tab2', tab2: 'tab3', tab3: 'tab1' };
		const currentTab = document.querySelector('.tab-active');
		const tab = currentTab.dataset.tab;
		const previousTabContent = document.querySelector('.tab-pane.tab-active');
		if (map[tab] === 'tab3') {
			nextButton[2].classList.add('hidden');
		}
		const nextTab = document.querySelector(`[data-tab=${map[tab]}]`);
		const nextTabContent = document.querySelector(`#${map[tab]}`);

		currentTab.classList.remove('tab-active');
		previousTabContent.classList.remove('tab-active');
		nextTab.classList.add('tab-active');
		nextTabContent.classList.add('tab-active');
		window.scrollTo(0, 0);
	}

	package1.addEventListener('click', () => {
		option1.checked = true;
		switchBorders([package1, package2]);
		updateSelectedPackage('Standard', package1.querySelector('.price').textContent);
		updateCheckout();
		calculateTotalPrice();
		populateGravityForm();
		hideUnavailableOptions();
		checkoutOrWebShop.classList.remove('hidden');
	});

	package2.addEventListener('click', () => {
		option2.checked = true;
		switchBorders([package2, package1]);
		updateSelectedPackage('Plus', package2.querySelector('.price').textContent);
		updateCheckout();
		checkoutOrWebShop.classList.add('hidden');
		calculateTotalPrice();
		populateGravityForm();
		hideUnavailableOptions();
		systems.forEach((system, i) => {
			system.querySelector('input').checked = false;
			system.classList.remove('border-primary-500');
			system.classList.add('border-primary-650');
		});
	});

	function updateSelectedPackage(selectedPackage, price) {
		const data = useGetLocalStorage('contrl-checkout') || {};
		const newData = {
			selectedPackage: {
				name: selectedPackage,
				price,
			},
		};
		if (selectedPackage === 'Plus' && data.selectedSystem) {
			delete data.selectedSystem;
		}
		useSetLocalStorage('contrl-checkout', {
			...data,
			...newData,
		});
	}

	backToContrlButton.addEventListener('click', function (e) {
		e.preventDefault();
		localStorage.removeItem('contrl-checkout');
		window.location.href = backToContrlButton.href;
	});

	checkBoxes.forEach((el, i) => {
		const title = el.querySelector('span').textContent;
		const price = el.querySelector('.price')?.textContent?.split(' ')[0];

		if (arr.length < 12) {
			arr.push({
				title,
				price,
			});
		}

		el.addEventListener('click', () => {
			const data = useGetLocalStorage('contrl-checkout') || {};
			toggleBorder(el);
			const option = data.checkedOptions.find((el) => el.title === title);
			option.checked = !option.checked;
			localStorage.setItem('contrl-checkout', JSON.stringify({ ...data }));
			calculateTotalPrice();
			populateExtras();
			populateExtrasPrice();
			populateGravityForm();

			return;
		});
	});

	if (!checkedOptions) {
		useUpdateLocalStorage(arr);
	}

	function useUpdateLocalStorage(newData) {
		const data = useGetLocalStorage('contrl-checkout') || {};
		localStorage.setItem('contrl-checkout', JSON.stringify({ ...data, checkedOptions: newData }));
	}

	function toggleBorder(element) {
		if (!element) return;
		const checkbox = element.querySelector('input');
		element.classList.toggle('border-primary-650');
		element.classList.toggle('border-primary-500');
		checkbox.checked = !checkbox.checked;
	}

	function selectCheckbox(arr, i, selector, keyname) {
		const otherCheckbox = [...arr].filter((_, index) => i !== index)[0];
		switchBorders([arr[i], otherCheckbox]);

		const selectedSystem = arr[i].querySelector(selector).textContent;
		const prevData = useGetLocalStorage('contrl-checkout') || {};
		const newData = { ...prevData, [keyname]: selectedSystem };

		useSetLocalStorage('contrl-checkout', newData);

		updateCheckout();
		populateGravityForm();
		calculateTotalPrice();
		hideUnavailableOptions();
		populateExtras();
	}

	const contracts = document.querySelectorAll('.contract');

	contracts.forEach((contract, i) => {
		contract.addEventListener('click', () => selectCheckbox(contracts, i, '.contract-type', 'selectedContract'));
	});

	userButtons.forEach((btn, i) =>
		btn.addEventListener('click', () => {
			const prevData = useGetLocalStorage('contrl-checkout') || {};

			const newData = { ...prevData, users: prevData?.users ?? 1 };
			if (i === 0 && newData.users !== 1) {
				newData.users -= 1;
			}

			if (i === 1) {
				newData.users += 1;
			}

			useSetLocalStorage('contrl-checkout', newData);
			document.querySelector('#extra_users').textContent = newData.users;
			const includedString = newData.users <= 1 ? 'Ingår' : `${49 * (newData.users - 1)} kr`;
			document.querySelector('.included').textContent = includedString;
			calculateTotalPrice();
			populateGravityForm();

			updateCheckout();
		})
	);
	initialUiUpdate();

	function updateCheckout() {
		const data = useGetLocalStorage('contrl-checkout') || {};
		const checkout = document.querySelector('.selected-package');

		if (data.selectedPackage) {
			const [selectedPackage, selectedPackagePrice] = checkout.querySelectorAll('span');
			selectedPackage.textContent = data.selectedPackage.name;
			selectedPackagePrice.textContent = `${data.selectedPackage.price} kr/mån`;
		}

		if ('users' in data) {
			const userContainer = document.querySelector('.numberOfUsers');
			const includedString = data.users <= 1 ? 'Ingår' : `${49 * (data.users - 1)} kr/mån`;
			userContainer.textContent = `${data.users} st, ${includedString}`;
		}

		if (data.selectedContract) {
			document.querySelectorAll('.contract-length').forEach((el) => (el.textContent = `${parseInt(data.selectedContract)} mån`));
		}

		checkIfCanProceed();
	}
	function calculateTotalPrice() {
		const { checkedOptions, users, selectedPackage } = useGetLocalStorage('contrl-checkout');
		const userPrice = users > 1 ? 49 * (users - 1) : 0;

		const additions = checkedOptions?.filter((el) => el.checked && el.title !== 'Uppstartshjälpen').reduce((acc, curr) => acc + parseInt(curr.price), 0);

		const price = parseInt(selectedPackage?.price ?? 0) + (userPrice ?? 0) + (additions ?? 0);

		document.querySelectorAll('.total-price').forEach((el) => (el.textContent = `${price} kr/mån`));

		return price;
	}
	function useGetLocalStorage(selector = 'contrl-checkout') {
		return JSON.parse(localStorage.getItem(selector)) || {};
	}
	function useSetLocalStorage(selector, obj) {
		localStorage.setItem(selector, JSON.stringify(obj));
	}
	function initialUiUpdate() {
		const data = useGetLocalStorage('contrl-checkout') || {};
		const map = {
			'3 månader': [threeMonthContract, twelveMonthContract],
			'12 månader': [twelveMonthContract, threeMonthContract],
			Standard: [package1, package2],
			Plus: [package2, package1],
			Kassa: [checkout, webshop],
			Webshop: [webshop, checkout],
		};
		switchBorders(map[data.selectedContract]);
		switchBorders(map[data.selectedPackage?.name]);

		if (data.selectedPackage?.name !== 'Plus') {
			switchBorders(map[data.selectedSystem]);
		}

		if (data.selectedPackage?.name === 'Plus') {
			checkoutOrWebShop.classList.add('hidden');
		}

		if ('users' in data) {
			document.querySelector('#extra_users').textContent = data.users;
		}

		updateCheckout();
		populateExtras();
		checkIfCanProceed();
		populateExtrasPrice();
		calculateTotalPrice();
		populateGravityForm();

		const itemsToToggle = data?.checkedOptions?.filter((el) => el.checked);
		[...checkBoxes].map((el) => {
			const title = el.querySelector('span').textContent;
			const hit = itemsToToggle?.filter((el) => el.title === title) || [];
			if (hit.length) {
				el.querySelector('input').checked = true;
			}
		});
		hideUnavailableOptions();
	}

	function switchBorders(arr) {
		if (!arr) return;
		const [toToggled, toUntoggled] = arr;
		toToggled.classList.add('border-primary-500');
		toToggled.classList.remove('border-primary-650');
		toUntoggled.classList.add('border-primary-650');
		toUntoggled.classList.remove('border-primary-500');
		toToggled.querySelector('input').checked = true;
		toUntoggled.querySelector('input').checked = false;
		const selectedText = toToggled.querySelector('.selectedRadio');
		const unSelectedText = toUntoggled.querySelector('.selectedRadio');
		if (selectedText) {
			selectedText.classList.remove('hidden');
		}
		if (unSelectedText) {
			unSelectedText.classList.add('hidden');
		}
	}

	function checkIfCanProceed() {
		const data = useGetLocalStorage('contrl-checkout') || {};

		const canProceed = 'selectedPackage' in data && 'selectedContract' in data && ('selectedSystem' in data || data.selectedPackage.name === 'Plus');
		const tabButtons = document.querySelectorAll('.tab-button');
		const nextButton = document.querySelector('.nextButton');

		if (canProceed) {
			nextButton.removeAttribute('disabled');
			tabButtons.forEach((tabButton) => (tabButton.style.pointerEvents = 'auto'));
		} else {
			tabButtons.forEach((tabButton) => (tabButton.style.pointerEvents = 'none'));
			nextButton.disabled = true;
		}
	}

	function populateExtras() {
		const containers = document.querySelectorAll('.extras-container');
		const data = useGetLocalStorage('contrl-checkout') || {};
		if (!data?.checkedOptions?.length) return;

		const htmlStringToReplace = data.checkedOptions
			.filter((el) => el.checked && !el.hidden)
			.map((option) => {
				return `<div class="flex justify-between items-center">
                <div class="text-white text font-semibold flex items-center text-sm py-2 gap-2">
                    <span>${option.title}</span>
                </div>
                <span class="text-sm">${option.price + (option.title === 'Uppstartshjälpen' ? ' kr' : ' kr/mån')}</span>
            </div>`;
			})
			.join('');
		const ifNoneSelected = `<span class="italic">Inga tillval valda</span>`;

		containers.forEach((container) => (container.innerHTML = htmlStringToReplace || ifNoneSelected));
	}
	function populateExtrasPrice() {
		const extraPriceContainers = document.querySelectorAll('.total-extra-price');
		const { checkedOptions } = useGetLocalStorage('contrl-checkout');

		if (checkedOptions) {
			const totalPricePerMonth = checkedOptions
				.filter((el) => el.checked && !el.hidden && el.title !== 'Uppstartshjälpen')
				.reduce((acc, curr) => acc + parseInt(curr.price), 0);
			extraPriceContainers.forEach((container) => (container.textContent = `${totalPricePerMonth} kr/mån`));
			const totalOnetimeCost = checkedOptions.find((el) => el.title === 'Uppstartshjälpen' && el.checked)?.price;
			const oneTimeCostsContainer = document.querySelectorAll('.one-time-costs');
			oneTimeCostsContainer.forEach((container) => {
				if (totalOnetimeCost) {
					container.classList.remove('hidden');
					container.querySelector('.price').textContent = `${totalOnetimeCost} kr`;
				} else {
					container.classList.add('hidden');
				}
			});
		}
	}

	function populateGravityForm() {
		const { checkedOptions, selectedContract, selectedPackage, selectedSystem, users } = useGetLocalStorage('contrl-checkout');

		if (checkedOptions) {
			extras.querySelector('textarea').value = checkedOptions
				.filter((el) => el.checked && !el.hidden)
				.map((option) => option.title)
				.join(', ');
			const oneTimePrice = checkedOptions
				.filter((el) => el.checked && el.title === 'Uppstartshjälpen')
				.reduce((acc, curr) => acc + parseInt(curr.price), 0);
			oneTime.querySelector('input').value = oneTimePrice;
		}

		if (selectedContract) {
			period.querySelector('input').value = selectedContract;
		}

		if (selectedPackage) {
			packet.querySelector('input').value = selectedPackage.name;
		}

		if (selectedSystem) {
			if (selectedPackage?.name === 'Plus') {
				system.querySelector('input').value = 'Båda';
				return;
			}
			system.querySelector('input').value = selectedSystem;
		}

		if (users) {
			usersForm.querySelector('input').value = users;
		}

		monthly.querySelector('input').value = calculateTotalPrice();
	}

	function hideUnavailableOptions() {
		const data = useGetLocalStorage('contrl-checkout');
		const { selectedPackage, selectedSystem, checkedOptions } = data;
		const StandardCheckoutMap = ['Bambora Checkout'];
		const StandardWebshopMap = ['Bambora Terminal', 'Klarna Instore', 'Bordsstativ', 'Kvittoskrivare till kassa', 'Scanner till kassa', 'Service'];
		const checkBoxes = document.querySelectorAll('.checkbox-single');
		const arr = [];
		const hardwareContainer = document.querySelector('.hardware_container');
		checkBoxes.forEach((checkbox, checkboxes) => {
			const fn = (title) => checkedOptions.find((el) => el.title === title);

			const title = checkbox.querySelector('span').textContent;
			const price = checkbox.querySelector('.price').textContent;
			const checked = checkbox.querySelector('input').checked || fn(title)?.checked;

			if (!selectedPackage?.name) return;
			if (selectedPackage.name === 'Standard') {
				if (selectedSystem === 'Kassa') {
					if (StandardCheckoutMap.includes(title)) {
						checkbox.classList.add('hidden');
						hardwareContainer.classList.remove('hidden');

						arr.push({ title, price, checked, hidden: true });
						return;
					}
					checkbox.classList.remove('hidden');
				}
				if (selectedSystem === 'Webshop') {
					if (StandardWebshopMap.includes(title)) {
						checkbox.classList.add('hidden');
						hardwareContainer.classList.add('hidden');
						arr.push({ title, price, checked, hidden: true });
						return;
					}
					checkbox.classList.remove('hidden');
				}
				arr.push({ title, price, checked });
			}
			if (selectedPackage.name === 'Plus') {
				arr.push({ title, price, checked });
				checkbox.classList.remove('hidden');
				hardwareContainer.classList.remove('hidden');
			}
		});
		localStorage.setItem('contrl-checkout', JSON.stringify({ ...data, checkedOptions: arr }));
		populateExtras();
		populateExtrasPrice();
	}
});

//# sourceMappingURL=order-page.js.map
